export default __webpack_public_path__ + "static/media/Aura-Egg__71.1877569f.png";